import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '../../components/ui/PageLayout';
import { GitFork } from 'lucide-react';
import RepositoriesConnectedTable from '../../components/repositories/RepositoriesConnectedTable';

export default function StreamsRepositoriesTab({ projects, streamReposLoading, streamReposFlat }: any) {
  const navigate = useNavigate();

  return (
    <div
      role="tabpanel"
      id="stream-tabpanel-repositories"
      aria-labelledby="stream-tab-repositories"
    >
      <div className="section-block-mdl">
        {projects.length === 0 ? (
          <EmptyState
            icon={<GitFork className="w-10 h-10 text-slate-500" />}
            title="No projects yet"
            description="Add a project to connect repositories to this stream."
          />
        ) : (
          <RepositoriesConnectedTable
            repositories={streamReposFlat}
            loading={streamReposLoading}
            navigate={navigate}
            emptyIcon={<GitFork className="w-12 h-12 text-slate-500" />}
            emptyTitle="No repositories in this stream."
            emptyDescription="Connect repositories from a project in this stream."
          />
        )}
      </div>
    </div>
  );
}
